<template>
  <div>
    <v-date-picker
      v-model="date"
      :max-date="new Date()"
      mode="date"
      :popover="{ visibility: 'focus' }"
      is-required
    >
      <template v-slot="{ inputValue, inputEvents }">
        <input
          class="input"
          :value="inputValue"
          v-on="inputEvents"
          :placeholder="placeholder"
          :name="name"
          :id="id"
          required
        />
      </template>
    </v-date-picker>
  </div>
</template>

<script>
export default {
  props: ["initalDate", "id", "name", "placeholder"],

  data() {
    return {
      date: this.initialDate || "",
    };
  },
};
</script>

<style></style>
